import { useEffect } from 'react';
import { Metrics } from '../../utils/metrics';
export function useTelemetry(componentName) {
    useEffect(function () {
        if (typeof window !== 'undefined') {
            Metrics.sendMetricOnce('awsui-viewport-width', window.innerWidth || 0);
            Metrics.sendMetricOnce('awsui-viewport-height', window.innerHeight || 0);
        }
        Metrics.logComponentLoaded();
        Metrics.logComponentUsed(componentName.toLowerCase());
    }, []);
}
//# sourceMappingURL=index.js.map